import { render, staticRenderFns } from "./clienttevredenheidsonderzoek.vue?vue&type=template&id=22e7dd3b&"
import script from "./clienttevredenheidsonderzoek.vue?vue&type=script&lang=js&"
export * from "./clienttevredenheidsonderzoek.vue?vue&type=script&lang=js&"
import style0 from "./clienttevredenheidsonderzoek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default})
